import { locales } from '@americanexpress/conditional-features';

const {
  EN_AU,
  EN_CA,
  EN_GB,
  EN_NZ,
  EN_US,
  FR_CA,
} = locales;

export const hasDisableTravelerTooltipRule = [EN_CA, FR_CA];
export const hasAnalyticsRule = [EN_US];

export const hasLxpSearchRule = {
  devFlag: 'lxpSearch',
  devLocales: [EN_US, EN_CA, FR_CA, EN_GB, EN_AU, EN_NZ],
  prodLocales: [EN_US],
};
